// extracted by mini-css-extract-plugin
export default {"root":"DocumentsMenuLabel_root__BnPXG","root_sub":"DocumentsMenuLabel_root_sub__NI-Fu"};